import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'al2010',
    ecrans: ['00-2',
             '01-2']
});
